export default function _utilsGlobalAlert() {
    /**
     * Root element (removed from the DOM on dismiss).
     * @const {string}
     */
    const ALERT_SELECTOR = '[data-component="utils-global-alert"]';

    /**
     * Close control (shared convention with cookie / alert banners).
     * @const {string}
     */
    const CLOSE_BTN = '[data-pnp-element="close-btn"]';

    document.querySelectorAll(ALERT_SELECTOR).forEach((element) => {
        const alertRoot = element;

        if (alertRoot.dataset.utilsGlobalAlertInit === 'true') {
            return;
        }

        const closeBtn = alertRoot.querySelector(CLOSE_BTN);

        if (!closeBtn) {
            return;
        }

        alertRoot.dataset.utilsGlobalAlertInit = 'true';

        closeBtn.addEventListener('click', () => {
            alertRoot.remove();
        });
    });
}

_utilsGlobalAlert();
